import { vMaska } from 'maska'

// Need to use data-maska-tokens (formUtils.ts - dataMaskaTokens) wherever input uses maska
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('maska', vMaska)
})
